import './FormProviderControl.scss';
import { ReactNode } from 'react';
import { FormProvider, SubmitErrorHandler, SubmitHandler, UseFormReturn } from 'react-hook-form';
import clsx from 'clsx';

const BUTTON_INPUT_TYPES = new Set(['button', 'submit', 'reset', 'image']);

/** Enter в поле ввода отправил бы форму неявно (в textarea — перенёс строку); кнопку и ссылку он нажимает. */
const isEntryField = (target: EventTarget) =>
    target instanceof HTMLTextAreaElement ||
    (target instanceof HTMLInputElement && !BUTTON_INPUT_TYPES.has(target.type));

export interface IFormProviderControlProps {
    children: ReactNode;
    className?: string;
    formMethods: UseFormReturn<any, any>;
    onSubmit: SubmitHandler<any>;
    onInvalid?: SubmitErrorHandler<any>;
    ignoreEnterSubmit?: boolean;
    id?: string;
    autoComplete?: string;
    /** Сигнал для resolver-а, что началась именно submit-валидация всей формы. */
    onSubmitValidationStart?: () => void;
    onSubmitValidationEnd?: () => void;
}

const FormProviderControl = ({
    children,
    className = '',
    formMethods,
    onSubmit,
    onInvalid,
    ignoreEnterSubmit = true,
    id,
    autoComplete,
    onSubmitValidationStart,
    onSubmitValidationEnd,
}: IFormProviderControlProps) => {
    return (
        <FormProvider {...formMethods}>
            <form
                name={id}
                id={id}
                role="presentation"
                tabIndex={-1}
                onSubmit={(e) => {
                    if (e.target === e.currentTarget) {
                        onSubmitValidationStart?.();
                        formMethods
                            .handleSubmit(
                                onSubmit,
                                onInvalid,
                            )(e)
                            .catch(() => {})
                            .finally(onSubmitValidationEnd);
                    }
                }}
                autoComplete={autoComplete}
                className={clsx('base-form-provider', className)}
                onKeyDown={(e) => {
                    if (ignoreEnterSubmit == true && e.key == 'Enter' && isEntryField(e.target)) {
                        e.preventDefault();
                    }
                }}
            >
                {children}
            </form>
        </FormProvider>
    );
};

export default FormProviderControl;
